/* eslint-disable @typescript-eslint/camelcase */
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { error } from '../../utils/messages';

export const advanceConfigSchema = yupResolver(
  yup.object().shape({
    enterpriseId: yup.string().required(error.required)
  })
);

export const billingAlertsSchema = yupResolver(
  yup.object().shape({
    enterpriseId: yup
      .array()
      .of(yup.string())
      .required(error.required)
      .min(1, error.required),
    dueDate: yup.date().required(error.required)
  })
);

export const graphSchema = yupResolver(
  yup.object().shape({
    analyticsId: yup.string().required(error.required),
    section: yup.string().required(error.required),
    existingTab: yup.string().required(error.required),
    title: yup.string().required(error.required),
    description: yup.string().required(error.required),
    download: yup.string().required(error.required)
  })
);

export const creativesSchema = yupResolver(
  yup.object().shape({
    link: yup.string().required(error.required),
    linkLabel: yup.string().required(error.required)
  })
);

export const walkthroughConfigSchema = yupResolver(
  yup.object().shape({
    sectionKey: yup
      .string()
      .required(error.required)
      .matches(
        /^[a-z0-9-]+$/,
        'Use lowercase letters, numbers, and hyphens only (e.g. "ndr-dashboard")'
      ),
    audience: yup
      .array()
      .of(yup.string().oneOf(['b2b', 'b2c']))
      .min(1, 'Select at least one audience (b2b, b2c, or both)')
      .required(error.required),
    version: yup
      .number()
      .typeError('Version must be a number')
      .min(1, 'Version must be 1 or greater')
      .required(error.required),
    steps: yup
      .array()
      .of(
        yup.object().shape({
          chip: yup.string().required(error.required),
          heading: yup.string().required(error.required),
          body: yup.string().required(error.required),
          videoUrl: yup.string().required(error.required),
          playbackRate: yup
            .number()
            .transform((value, original) =>
              original === '' || original === null ? undefined : value
            )
            .typeError('Must be a number')
            .positive('Must be greater than 0')
            .notRequired(),
          speedRampAt: yup
            .number()
            .transform((value, original) =>
              original === '' || original === null ? undefined : value
            )
            .typeError('Must be a number')
            .min(0, 'Must be 0 or greater')
            .notRequired()
        })
      )
      .min(1, 'At least one step is required')
      .required(error.required)
  })
);

export const accessControlSchema = yupResolver(
  yup.object().shape({
    userAccessType: yup.string().optional(),
    emailid: yup
      .array()
      .of(yup.string().email('Invalid email format'))
      .required(error.required)
      .min(1, error.required)
  })
);
